module.exports = __webpack_public_path__ + "files/a2a22a220fa9588f64cbb732ff54ee78.png";